var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgScan(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.72462 2.5C3.04921 2.5 2.5 3.04921 2.5 3.72462V5.5C2.5 6.05228 2.05228 6.5 1.5 6.5C0.947715 6.5 0.5 6.05228 0.5 5.5V3.72462C0.5 1.94464 1.94464 0.5 3.72462 0.5H5.5C6.05228 0.5 6.5 0.947715 6.5 1.5C6.5 2.05228 6.05228 2.5 5.5 2.5H3.72462Z",
    fill: "#525A6A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.5 1.5C12.5 0.947715 12.9477 0.5 13.5 0.5H15.2754C17.0554 0.5 18.5 1.94464 18.5 3.72462V5.5C18.5 6.05228 18.0523 6.5 17.5 6.5C16.9477 6.5 16.5 6.05228 16.5 5.5V3.72462C16.5 3.04921 15.9508 2.5 15.2754 2.5H13.5C12.9477 2.5 12.5 2.05228 12.5 1.5Z",
    fill: "#525A6A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.5 12.5C18.0523 12.5 18.5 12.9477 18.5 13.5V15.2754C18.5 17.0554 17.0554 18.5 15.2754 18.5H13.5C12.9477 18.5 12.5 18.0523 12.5 17.5C12.5 16.9477 12.9477 16.5 13.5 16.5H15.2754C15.9508 16.5 16.5 15.9508 16.5 15.2754V13.5C16.5 12.9477 16.9477 12.5 17.5 12.5Z",
    fill: "#525A6A"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.5 12.5C2.05228 12.5 2.5 12.9477 2.5 13.5V15.2754C2.5 15.9508 3.04921 16.5 3.72462 16.5H5.5C6.05228 16.5 6.5 16.9477 6.5 17.5C6.5 18.0523 6.05228 18.5 5.5 18.5H3.72462C1.94464 18.5 0.5 17.0554 0.5 15.2754V13.5C0.5 12.9477 0.947715 12.5 1.5 12.5Z",
    fill: "#525A6A"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.5 9.5C0.5 8.94771 0.947715 8.5 1.5 8.5H17.5C18.0523 8.5 18.5 8.94771 18.5 9.5C18.5 10.0523 18.0523 10.5 17.5 10.5H1.5C0.947715 10.5 0.5 10.0523 0.5 9.5Z",
    fill: "#525A6A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScan);
export default __webpack_public_path__ + "static/media/scan.ba480f6939e2fe63f07341c5bb541778.svg";
export { ForwardRef as ReactComponent };